import { EmLocalTime } from "./em-local-time";

// Register custom elements

customElements.define("em-local-time", EmLocalTime);
